import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../cn';

export function EmptyState({ icon, title, text, action }: { icon: ReactNode; title: string; text?: ReactNode; action?: ReactNode }) {
  return (
    <div className="bf-empty">
      <span className="bf-empty-icon">{icon}</span>
      <p className="bf-empty-title">{title}</p>
      {text && <p className="bf-empty-text">{text}</p>}
      {action}
    </div>
  );
}

export function Callout({ tone = 'info', children }: { tone?: 'info' | 'success' | 'warning' | 'danger'; children: ReactNode }) {
  const Icon = tone === 'danger' ? CircleAlert : tone === 'warning' ? TriangleAlert : tone === 'success' ? CircleCheck : Info;
  return (
    <div className={cn('bf-callout', tone !== 'info' && `bf-callout--${tone}`)} role={tone === 'info' || tone === 'success' ? undefined : 'alert'}>
      <Icon aria-hidden />
      <div>{children}</div>
    </div>
  );
}

export function Skeleton({ style }: { style?: CSSProperties }) {
  return <div className="bf-skeleton" style={{ height: 16, ...style }} aria-hidden />;
}
